import { useState } from 'react'

// PRD 00's storage convention (see useAuthToken.ts) applied to a single
// "shown once" boolean flag - no cross-tab reactivity requirement here, so a
// plain useState initialized from localStorage is enough (unlike the auth
// session, which needs useSyncExternalStore for apiRequest's non-React reads).
export function useDismissedBanner(key: string): [boolean, () => void] {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(key) === 'true'
    } catch {
      return false
    }
  })

  function dismiss() {
    setDismissed(true)
    try {
      localStorage.setItem(key, 'true')
    } catch {
      // Storage unavailable (e.g. private browsing) - dismissal still holds
      // for this session via the state above, just doesn't persist.
    }
  }

  return [dismissed, dismiss]
}
